import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  FlatList,
} from "react-native";
import EditMember from "./editMember";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { Modal } from "react-native-web";
import { useRecoilState } from "recoil";
import { univer } from "../reducer";
import { apiservice } from "../service/api";
import "./dragdrop.css";

const { width, height } = Dimensions.get("window");

const manageMembers = () => {
  const [data1, setdata1] = useState([]);
  const [page, setpage] = useState(0);
  const [fill, setFill] = useState("");
  const [modal, setmodal] = useState(false);
  const [university, setuniversity] = useRecoilState(univer);
  const [body, setbody] = useState({});

  // Drag and drop states
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [updateTimeout, setUpdateTimeout] = useState(null);

  async function getallUniversity() {
    const res = await apiservice({
      path: "/authen/allinfo?university_id=" + university.id,
      method: "get",
    });
    if (res.status == 200) {
      setdata1(res.data.data);
    }
  }

  useEffect(() => {
    getallUniversity();
  }, []);

  // Cleanup effect for drag events
  useEffect(() => {
    return () => {
      // Clear any pending timeout
      if (updateTimeout) {
        clearTimeout(updateTimeout);
      }
    };
  }, [updateTimeout]);

  // HTML5 Drag and Drop handlers
  const handleDragStart = (e, item, index) => {
    console.log('Drag started for item:', item.firstname + ' ' + item.lastname, 'at index:', index);

    setDraggedItem(item);
    setDraggedIndex(index);

    // Set drag data
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', e.target.outerHTML);
    e.dataTransfer.setData('text/plain', item.id.toString());

    // Add visual feedback
    e.target.classList.add('dragging');
  };

  const handleDragEnd = (e) => {
    console.log('Drag ended');

    // Clean up
    e.target.classList.remove('dragging');
    setDraggedItem(null);
    setDraggedIndex(null);
    setDragOverIndex(null);

    // Remove visual feedback from all elements
    const rows = document.querySelectorAll('.draggable-row');
    rows.forEach(row => {
      row.classList.remove('drag-over');
    });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDragEnter = (e, index) => {
    e.preventDefault();

    if (draggedIndex !== null && draggedIndex !== index) {
      setDragOverIndex(index);
      e.target.closest('.draggable-row')?.classList.add('drag-over');
    }
  };

  const handleDragLeave = (e) => {
    e.target.closest('.draggable-row')?.classList.remove('drag-over');
  };

  const handleDrop = async (e, dropIndex) => {
    e.preventDefault();
    e.stopPropagation();

    const targetRow = e.target.closest('.draggable-row');
    targetRow?.classList.remove('drag-over');

    if (draggedIndex === null || draggedIndex === dropIndex) {
      return;
    }

    console.log('Dropping at index:', dropIndex, 'from index:', draggedIndex);

    // Update array order
    await updateArrayOrder(dropIndex);
  };

  // Update array order during drag
  const updateArrayOrder = async (dropIndex) => {
    if (draggedIndex === null || draggedIndex === dropIndex) {
      return;
    }

    const filteredData = data1.filter((item) =>
      item.firstname.includes(fill) ||
      item.lastname.includes(fill) ||
      item.nickname.includes(fill)
    );
    const newData = [...filteredData];

    // Remove dragged item from its original position
    const draggedItemData = newData.splice(draggedIndex, 1)[0];

    // Insert it at the new position
    newData.splice(dropIndex, 0, draggedItemData);

    // Update the original data array to maintain order
    const updatedData = [...data1];
    const filteredIndexes = [];

    // Find indexes of filtered items in original data
    data1.forEach((item, index) => {
      if (item.firstname.includes(fill) ||
        item.lastname.includes(fill) ||
        item.nickname.includes(fill)) {
        filteredIndexes.push(index);
      }
    });

    // Update positions in the original data
    newData.forEach((item, newIndex) => {
      const originalIndex = filteredIndexes[newIndex];
      if (originalIndex !== undefined) {
        updatedData[originalIndex] = item;
      }
    });

    await Promise.all(
      updatedData.map((item, index) => {
        return apiservice({
          path: "/authen/updateinfo",
          method: "put",
          body: { ...item, sort_order: index + 1 }
        })
      }))

    // setdata1(updatedData);

    getallUniversity();

    // Update the dragged index to the new position
    setDraggedIndex(dropIndex);

    // Debounced server update to prevent too many API calls
    if (updateTimeout) {
      clearTimeout(updateTimeout);
    }

    const timeoutId = setTimeout(async () => {
      try {
        const orderData = newData.map((item, index) => ({
          id: item.id,
          sort_order: index + 1
        }));

        await apiservice({
          path: "/authen/updateOrder",
          method: "put",
          body: { members: orderData }
        });
        console.log("Member order updated successfully");
      } catch (error) {
        console.log("Error updating member order:", error);
      }
    }, 500); // Wait 500ms after last move before updating server

    setUpdateTimeout(timeoutId);
  };

  async function deleteMember() {
    const res = await apiservice({
      path: "/authen/deleteinfo",
      method: "delete",
      body,
    });

    if (res.status == 200) {
      getallUniversity();
      setmodal(false);
    }
  }

  async function handleGenerateUrl() {
    const res = await apiservice({
      path: "/authen/university",
      method: "post",
      body: {
        universityId: university.id,
      },
    });

    if (res.status == 200) {
      const url = `https://app-mcon.asiaconnectth.com/createuniversity/${res.data.id}`;
      await navigator.clipboard.writeText(url);

      alert("URL copied to clipboard!");
    }
  }

  return (
    <View style={styles.container}>
      <Modal
        animationType="none"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          setmodal(!modal);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              ต้องการลบข้อมูลนี้ใช่หรือไหม
            </Text>
            <View
              style={{
                width: width * 0.25,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  deleteMember();
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Bold",
              color: "#202020",
            }}
          >
            จัดการสมาชิก
          </Text>

          <Text
            style={{
              width: width * 0.591,
              fontSize: 12,
              fontFamily: "Prompt-Regular",
              color: "#666",
              marginBottom: 10,
            }}
          >
            💡 ลากที่ไอคอน ⋮⋮ เพื่อเรียงลำดับรายการ (Drag to reorder)
          </Text>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.1,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: width * 0.235,
                height: height * 0.037,
                flexDirection: "row",
              }}
            >
              <TextInput
                value={fill}
                onChangeText={setFill}
                onSubmitEditing={async () => {
                  const res = await apiservice({
                    path: "/authen/allinfo?university_id=" + university.id,
                    method: "get",
                  });
                  setdata1(
                    res.data.data.filter(
                      (items) =>
                        items.firstname.includes(fill) ||
                        items.lastname.includes(fill) ||
                        items.nickname.includes(fill)
                    )
                  );
                }}
                style={{
                  width: width * 0.8,
                  height: height * 0.037,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#00237740",
                  paddingLeft: 5,
                  fontFamily: "Prompt-Regular",
                  fontSize: 12,
                }}
              />
              <TouchableOpacity
                onPress={async () => {
                  const res = await apiservice({
                    path: "/authen/allinfo?university_id=" + university.id,
                    method: "get",
                  });
                  setdata1(
                    res.data.data.filter(
                      (items) =>
                        items.firstname.includes(fill) ||
                        items.lastname.includes(fill) ||
                        items.nickname.includes(fill)
                    )
                  );
                }}
                style={{
                  width: width * 0.022,
                  height: height * 0.037,
                  backgroundColor: "#002377",
                }}
              >
                <AntDesign
                  name="search1"
                  style={{ margin: "auto" }}
                  size={15}
                  color="#ffff"
                />
              </TouchableOpacity>
            </View>

            <TouchableOpacity
              onPress={handleGenerateUrl}
              style={{
                width: width * 0.075,
                height: height * 0.037,
                backgroundColor: "#43A2D4",
                borderRadius: 5,
              }}
            >
              <Text style={styles.TextButton}>+ เพิ่มสมาชิก</Text>
            </TouchableOpacity>
          </View>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.546,
              borderWidth: 1,
              overflow: "hidden",
              borderColor: "#C2C2C2",
              borderTopLeftRadius: 5,
              borderTopRightRadius: 5,
            }}
          >
            <div
              style={{
                width: width * 0.591,
                height: height * 0.054,
                backgroundColor: "#002377",
                display: 'flex',
                flexDirection: "row",
                justifyContent: "space-around",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
              }}
            >
              {/* Drag handle header */}
              <div style={{ width: 20, height: height * 0.054, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{
                  fontSize: 12,
                  color: "#FFF",
                  fontFamily: "Prompt-Regular"
                }}>

                </span>
              </div>

              <div style={{
                width: width * 0.103,
                height: height * 0.054,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <span style={{
                  fontSize: 20,
                  color: "#FFF",
                  fontFamily: "Prompt-Regular"
                }}>
                  ชื่อ
                </span>
              </div>

              <div style={{
                width: width * 0.095,
                height: height * 0.054,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <span style={{
                  fontSize: 20,
                  color: "#FFF",
                  fontFamily: "Prompt-Regular"
                }}>
                  สถานะ
                </span>
              </div>

              <div style={{
                width: width * 0.125,
                height: height * 0.054,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <span style={{
                  fontSize: 20,
                  color: "#FFF",
                  fontFamily: "Prompt-Regular"
                }}>
                  จัดการ
                </span>
              </div>
            </div>

            <div style={{ height: height * 0.492, overflowY: 'auto' }}>
              {data1.filter(
                (items) =>
                  items.firstname.includes(fill) ||
                  items.lastname.includes(fill) ||
                  items.nickname.includes(fill)
              ).map((item, index) => {
                const isCurrentlyDragging = draggedIndex === index;
                const isDropTarget = dragOverIndex === index;

                return (
                  <div
                    key={item.id || index}
                    data-row-index={index}
                    className={`draggable-row ${isDropTarget ? 'drag-over' : ''} ${isCurrentlyDragging ? 'dragging' : ''}`}
                    draggable={false}
                    onDragStart={(e) => handleDragStart(e, item, index)}
                    onDragEnd={handleDragEnd}
                    onDragOver={handleDragOver}
                    onDragEnter={(e) => handleDragEnter(e, index)}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(e, index)}
                    style={{
                      width: width * 0.591,
                      height: height * 0.1,
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      backgroundColor: isDropTarget
                        ? 'rgba(0, 35, 119, 0.1)'
                        : index % 2 == 0 ? "#ffffff" : "#E8E8E8",
                      opacity: isCurrentlyDragging ? 0.5 : 1,
                      transform: isCurrentlyDragging ? 'scale(1.02)' : 'scale(1)',
                      border: isDropTarget ? '2px dashed #002377' : 'none',
                      transition: isCurrentlyDragging ? 'none' : 'all 0.2s ease',
                      zIndex: isCurrentlyDragging ? 1000 : 1,
                      position: 'relative',
                      boxSizing: 'border-box',
                    }}
                  >
                    {/* Drag handle */}
                    {/* <div
                      className="drag-handle"
                      style={{
                        width: 20,
                        height: height * 0.1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(0, 35, 119, 0.2)',
                        cursor: 'grab',
                        userSelect: 'none',
                        padding: 0,
                      }}
                    >
                      <span style={{
                        color: '#002377',
                        fontSize: 14,
                        fontWeight: 'bold',
                        userSelect: 'none',
                        pointerEvents: 'none'
                      }}>
                        ⋮⋮
                      </span>
                    </div> */}

                    <div
                      style={{
                        width: width * 0.103,
                        height: height * 0.1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        paddingLeft: 20,
                        pointerEvents: 'none', // Prevent drag interference
                      }}
                    >
                      <span style={{
                        fontSize: 16,
                        fontFamily: "Prompt-Regular"
                      }}>{item.firstname + " " + item.lastname}</span>
                    </div>

                    <div
                      style={{
                        width: width * 0.095,
                        height: height * 0.1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents: 'none', // Prevent drag interference
                      }}
                    >
                      <span style={{
                        fontSize: 16,
                        fontFamily: "Prompt-Regular"
                      }}>
                        ใช้งาน
                      </span>
                    </div>

                    <div
                      style={{
                        width: width * 0.125,
                        height: height * 0.1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-evenly',
                        pointerEvents: 'auto', // Allow button interactions
                      }}
                    >
                      <button
                        onClick={() => {
                          setbody(item);
                          setpage(1);
                        }}
                        style={{
                          width: 100,
                          height: 30,
                          borderRadius: 5,
                          backgroundColor: "#002377",
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <span
                          style={{
                            fontSize: 16,
                            color: "#FFF",
                            fontFamily: "Prompt-Regular"
                          }}
                        >
                          รายละเอียด
                        </span>
                      </button>

                      <button
                        onClick={() => {
                          setbody(item);
                          setmodal(true);
                        }}
                        style={{
                          width: 70,
                          height: 30,
                          borderRadius: 5,
                          backgroundColor: "#D44343",
                          border: 'none',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <span style={{
                          fontSize: 16,
                          color: "#FFF",
                          fontFamily: "Prompt-Regular"
                        }}>ลบ</span>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </View>
        </View>
      )}

      {page == 1 && <EditMember setpages={setpage} body={body} />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Textheader: {
    fontSize: 20,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
  Textdata: { fontSize: 16, fontFamily: "Prompt-Regular" },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});
export default manageMembers;
